import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./store";
import { transitions, positions, Provider as AlertProvider } from "react-alert";
import "react-tippy/dist/tippy.css";
import AlertComponent from "./components/util/alertComponent";
import { AuthProvider } from "./contexts/authContext";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import TestPreviewComponent from "./components/Test/testPreviewComponent";
import ProtectedRoute from "./components/privateRoute";
import PreviewComponennt from "./components/preview/previewComponent";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import LoginComponent from "./components/login/loginComponent";
import ErrorComponent from "./components/error/errorComponent";
import WelcomeComponent from "./components/welcome/welcomeComponent";
import PrototypePreviewComponent from "./components/prototypePreview/prototypePreviewComponent";

// optional configuration
const options = {
  // you can also just use 'bottom center'
  position: positions.TOP_RIGHT,
  timeout: 5000,
  offset: "30px",
  // you can also just use 'scale'
  transition: transitions.SCALE,
};

ReactDOM.render(
  <Provider store={store}>
    <Router>
      <AuthProvider>
        <AlertProvider template={AlertComponent} {...options}>
          <DndProvider backend={HTML5Backend}>
            <Switch>
              <Route path={'/preview/:type/:id'} exact component={TestPreviewComponent} />
              <ProtectedRoute path="/preview-render/:id" exact component={PreviewComponennt} />

              <Route
                path="/prototype-render/:id"
                exact
                component={PrototypePreviewComponent}
              />
              <Route path="/login/:username/:token" exact component={LoginComponent} />
              <Route path={'/logout'} exact component={WelcomeComponent} />
              <Route path={'/home'} component={App} />
              <Route path={'/'} component={ErrorComponent} />
            </Switch>
          </DndProvider>
        </AlertProvider>
      </AuthProvider>
    </Router>
  </Provider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
